var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.125 3.125C2.77982 3.125 2.5 3.40482 2.5 3.75V12.5C2.5 12.8452 2.77982 13.125 3.125 13.125H11.875C12.2202 13.125 12.5 12.8452 12.5 12.5V3.75C12.5 3.40482 12.2202 3.125 11.875 3.125H3.125ZM1.25 3.75C1.25 2.71447 2.08947 1.875 3.125 1.875H11.875C12.9105 1.875 13.75 2.71447 13.75 3.75V12.5C13.75 13.5355 12.9105 14.375 11.875 14.375H3.125C2.08947 14.375 1.25 13.5355 1.25 12.5V3.75Z",
    fill: "#293C62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0.625C10.3452 0.625 10.625 0.904822 10.625 1.25V3.75C10.625 4.09518 10.3452 4.375 10 4.375C9.65482 4.375 9.375 4.09518 9.375 3.75V1.25C9.375 0.904822 9.65482 0.625 10 0.625Z",
    fill: "#293C62"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 0.625C5.34518 0.625 5.625 0.904822 5.625 1.25V3.75C5.625 4.09518 5.34518 4.375 5 4.375C4.65482 4.375 4.375 4.09518 4.375 3.75V1.25C4.375 0.904822 4.65482 0.625 5 0.625Z",
    fill: "#293C62"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 6.25C1.25 5.90482 1.52982 5.625 1.875 5.625H13.125C13.4702 5.625 13.75 5.90482 13.75 6.25C13.75 6.59518 13.4702 6.875 13.125 6.875H1.875C1.52982 6.875 1.25 6.59518 1.25 6.25Z",
    fill: "#293C62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.e38da7091d1bf5ae6ea8d813ddbaf6b2.svg";
export { ForwardRef as ReactComponent };